import { Component, ChangeDetectionStrategy, OnInit, inject } from '@angular/core';
import { SeoService } from '../../_services/seo/seo.service';
import { ConsentEmbedComponent } from '../../_components/consent-embed/consent-embed.component';

@Component({
    selector: 'app-a-propos',
    imports: [ConsentEmbedComponent],
    templateUrl: './a-propos.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './a-propos.component.scss'
})
export class AProposComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.set({
      title: 'À propos',
      description: 'Histoire, costumes, danses et spectacles de La Bourrée de Paris, groupe folklorique auvergnat fondé à Paris en 1925 et labellisé CIOFF.',
      path: '/a-propos',
    });
  }
}
